module.exports = __webpack_public_path__ + "static/media/S (196).77cb9834.jpg";